import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "formfort-cannot-load"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode(" There was a network error loading the form. This is most commonly caused by ad-blockers and firewalls.<br><strong>You may try:</strong><br><ul><li><a href=\"\">Reloading</a> the page. </li><li>Disabling your ad blocker. </li><li>Updating your firewall rules. </li><li>Allowing all <strong>*.onshape.com</strong> connections.</li><li><a href=\"https://www.onshape.com/en/domain-whitelisting\">Domain Whitelisting</a></li><li>Contacting support <strong>support@onshape.com</strong></li></ul>", 5)
const _hoisted_7 = [
  _hoisted_2
]
const _hoisted_8 = {
  key: 1,
  class: "formfort-app"
}
const _hoisted_9 = { class: "form-top-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_facet = _resolveComponent("form-facet")!
  const _component_unified_signup_form_facet = _resolveComponent("unified-signup-form-facet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFormUnloadable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.isTranslationReady && _ctx.formNotValidErrorMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.formNotValidErrorMsg, _ctx.formNotValidErrorMsg)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.formDefinition)
      ? (_openBlock(), _createElementBlock("div", {
          class: "formfort-app",
          ref: "appElement",
          key: `call-id-${_ctx.callId}`
        }, [
          (!_ctx.isUnifiedSignupForm)
            ? (_openBlock(), _createBlock(_component_form_facet, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.isUnifiedSignupForm)
            ? (_openBlock(), _createBlock(_component_unified_signup_form_facet, { key: 1 }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}